module.exports = __webpack_public_path__ + "static/media/marc-jacobs.58d0e43c.jpg";